<template>
  <Transition name="fade" mode="out-in">
    <CCard class="flex-shrink-0 h-auto pb-4 md:pb-5" v-if="!loading">
      <h4 class="text-lg md:text-xl text-dark font-semibold p-4 md:p-5">
        {{ $t("dashboard.charts.sort_title") }}
      </h4>
      <hr class="w-full h-[1px] bg-gray-300 mb-2" />
      <div class="px-5 pt-2 space-y-3">
        <CProfitCard
          v-for="(data, idx) of strategies"
          :key="idx"
          :title="data?.base_strategy_name"
          :total-profit="data?.total_profit"
          :percent-mean="data?.profit_all_percent_mean"
        />
      </div>
    </CCard>
  </Transition>
</template>
<script lang="ts" setup>
import CCard from "@/components/Card/CardWrapper.vue";
import { IBarChartData } from "@/types/components/chart";
import CProfitCard from "@/modules/Dashboard/components/CProfitCard.vue";

interface Props {
  strategies: IBarChartData[];
  loading?: boolean;
}

defineProps<Props>();
</script>
